import { useEffect, useState } from 'react';

import { useNavigationStore } from '@app/store/zustand';

const MINIMIZED_BREAKPOINT = 1460;
const MAXIMIZED_BREAKPOINT = 1707;

export const useFantasyLineupBreakpoint = (minWidth?: number, maxWidth?: number) => {
    const minWidthBreakpoint = minWidth || MINIMIZED_BREAKPOINT;
    const maxWidthBreakpoint = maxWidth || MAXIMIZED_BREAKPOINT;

    const isMinimized = useNavigationStore((state) => state.isMinimized);
    const [isWideDesktop, setIsWideDesktop] = useState(window.innerWidth >= minWidthBreakpoint);

    useEffect(() => {
        const breakpoint = isMinimized ? minWidthBreakpoint : maxWidthBreakpoint;

        const handleResize = () => {
            setIsWideDesktop(window.innerWidth >= breakpoint);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [isMinimized, minWidthBreakpoint, maxWidthBreakpoint]);

    return { isWideDesktop };
};
